<script>
	const timer = {
		template: '<span><i class="fa fa-clock-o fa-fw"></i>{{newTime}}</span>',
		props: ['time'],
		data(){
			return {
				runInterval: null,
				newTime: this.convert(this.time)
			}
		},
		methods: {
			convert: function(time){
				// console.log('Receive Time: ', time, typeof time)

				if(time == 0){
					// console.log('Starte..')
					return 'Startet..'
				} 

				let date = new Date()
				let diff = (date.getTime() - time)/1000
				if(diff < 0) diff = 0

					let seconds = Math.round( diff % 60 )
				seconds = seconds < 10 ? '0' + seconds : seconds

				return Math.floor(diff / 60) + ':' + seconds
			}
		},
		created(){
			// console.log('All my Props: ', this.time)

			this.runInterval = setInterval( () => {
				this.newTime =  this.convert(this.time)
			}, 1000)
		},
		beforeDestroy(){
			this.runInterval && clearInterval(this.runInterval)
		}	
	}

	export {timer}
</script>


// WEBPACK FOOTER //
// Helper.vue?1d4f2aa9